<template>
  <div class="footer wrap1920">
    <!-- <img src="../../assets/images/upload/cache_image/default/octweb2000-1-1-/global_top_nav_three.jpg" alt="" class="global_top_nav_three_bg">
    <img src="../../assets/images/upload/cache_image/default/octweb2000-1-1-/index_ewm.jpg" alt="" />-->
    <botton-navigation></botton-navigation>
    <botton-cooperative></botton-cooperative>
    <botton-copyright></botton-copyright>
  </div>
</template>
<script>
import BottonNavigation from '@/pages/components/bottonNavigation.vue'
import BottonCooperative from '@/pages/components/bottonCooperative.vue'
import BottonCopyright from '@/pages/components/bottonCopyright.vue'
export default {
  name: 'CommonBottonFrame',
  componentName: 'CommonBottonFrame',
  components: {
    BottonNavigation,
    BottonCooperative,
    BottonCopyright
  }
}
</script>
<style>
@import '../../assets/css/pages/html/footer.css';
</style>



// WEBPACK FOOTER //
// src/pages/components/commonBottonFrame.vue